<div class="p-3">
  <a [routerLink]="['../']" class="btn btn-sm btn-outline-secondary mb-3">← Back to list</a>
  <h4 *ngIf="agent" class="mb-1">{{ agent.code }} — {{ agent.name }}</h4>
  <div class="text-muted small mb-3" *ngIf="agent">
    Rate: {{ (isRedShareMode ? agent.rate : agent.rate * 100) | number:'1.0-2' }}%
  </div>

  <div class="card mb-3">
    <div class="card-body">
      <div class="mb-3">
        <label class="form-label fw-bolder mb-1">Period</label>
        <select class="form-select form-select-sm"
                [ngModel]="selectedPeriodKey"
                (ngModelChange)="onPeriodChange($event)">
          <option *ngFor="let o of periodOptions" [value]="o.key">
            {{ o.label }} ({{ o.from_date }} – {{ o.to_date }})
          </option>
        </select>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <div class="text-muted small">{{ period.label }}</div>
          <div class="fw-bolder">{{ period.from_date }} – {{ period.to_date }}</div>
        </div>
        <div class="text-end">
          <div class="text-muted small">Referral Wallet Payout</div>
          <div class="h4 mb-0">{{ periodCommission | number:'1.3-3' }}</div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="loading" class="text-muted">Loading…</div>

  <div class="card mb-3" *ngIf="!loading && dailyBreakdown.length > 0">
    <div class="card-body">
      <div class="fw-bolder mb-2">Daily Rolling Breakdown</div>
      <div class="text-muted small mb-2">Commission = Lose Value &times; Game Rate &times; 1% &times; Rate &times; Player Share (Game Rate is set in the automated rule, per game with general rate as fallback — today 50% — and applies to every level; Rate is the level rolling rate: L1 100% / L2 30% / L3 20%; each lose value pays every covered level)</div>
      <div class="rolling-day py-2 border-bottom"
           *ngFor="let row of dailyBreakdown">
        <div class="d-flex justify-content-between gap-3">
          <div>
            <div class="fw-semibold">{{ row.date }}</div>
            <div class="text-muted small"
                 *ngIf="gameBreakdown(row).length === 0 && row.formula_param && row.formula_param !== '-'">
              {{ row.formula_param }}
            </div>
          </div>
          <div class="text-end fw-semibold">
            {{ row.commission | number:'1.3-3' }}
            <div *ngIf="gameBreakdown(row).length > 0" class="small mt-1">
              <span *ngIf="row.verified" class="badge bg-success-subtle text-success border border-success-subtle"
                    title="The per-game breakdown below sums exactly to the amount paid.">✓ Verified</span>
              <span *ngIf="!row.verified" class="badge bg-danger-subtle text-danger border border-danger-subtle"
                    title="The per-game breakdown does not match the paid amount — investigate.">⚠ Check: breakdown {{ row.breakdown_total | number:'1.3-3' }}</span>
            </div>
          </div>
        </div>
        <div class="rolling-detail mt-2" *ngIf="gameBreakdown(row).length > 0">
          <div class="rolling-detail__row" *ngFor="let item of gameBreakdown(row)">
            <div>
              <span class="badge bg-light text-dark me-1">{{ item.source || ('P' + item.source_player_id) }}</span>
              <span class="badge bg-primary me-1">L{{ item.tier }}</span>
              <span>{{ item.game }}<ng-container *ngIf="item.game_type"> / {{ item.game_type }}</ng-container></span>
            </div>
            <div class="text-muted small">
              {{ calcText(item) }} = {{ item.commission | number:'1.3-6' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!loading && dailyBreakdown.length === 0" class="text-muted">
    No activity in this period.
  </div>
</div>
